import Fetch from "utils/fetch";

export const downloadData = () => {
  return Fetch.get('cadenciafornecedor/exportar').then(({ data }) => data);
}

export const downloadModel = () => {
  return Fetch.get('cadenciafornecedor/exportarModelo').then(({ data }) => data);
}
